import { useExperimentGroup } from 'shared/src/context/UserContext/useExperimentGroup';

/**
 * 무물라이브 실험(EXP1867) 참여 대상 여부 (A 대조군 / B 실험군).
 * 대조군도 CHECK_EXP_1867_TARGET 로깅에 프로필 상태·콘텐츠 정보가 필요하므로
 * UI 노출 게이트(`useIsMumulLiveExposed` = B군)와 분리한다.
 */
export const useIsMumulLiveExpTarget = () =>
  useExperimentGroup({ sno: 'EXP1867', targetGroups: ['A', 'B'] });
